import React from 'react';
import { withRouter } from 'react-router-dom';
import StackTrace from 'stacktrace-js';
import * as Sentry from '@sentry/react';

window.onerror = function(msg, file, line, col, error) {
  StackTrace.fromError(error).then(err => {
    StackTrace.report(
      err,
      `//${window.location.hostname}:${process.env.REACT_APP_LOGGER_PORT || 3334}/jsnlog.logger`,
      {
        type: "window.onerror",
        url: window.location.href,
        userId: window.userId,
        agent: window.navigator.userAgent,
        date: new Date(),
        msg: msg
      }
    );
  });
};

class ErrorHandle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    })

    StackTrace.fromError(error).then(err => {
      const key = '_vto';
      let user = localStorage.getItem(key);

      // let email;
      if (user) {
        user = JSON.parse(user);
        // email = user.email;
      }

      // const url = '/unicorn/errors';
      // const params = {
      //   error: error.toString(),
      //   errorInfo: err.toString(),
      //   url: window.location.href,
      //   userId: window.userId,
      //   agent: window.navigator.userAgent,
      //   date: new Date(),
      //   email,
      // };

      try {
        // const response = axios.post(url, params );
      } catch (error) {
        if (error) {
          console.log(error)
        }
      }
    });

    if (process.env.NODE_ENV === "production") {
      Sentry.captureException(error, scope => {
        scope.setContext("errorOrigin", {origin: "ErrorHandle error"});
        scope.setTag("vt_dev", "ErrorHandle error");
      });
      Sentry.captureException(errorInfo, scope => {
        scope.setContext("errorOrigin", {origin: "ErrorHandle errorInfo"});
        scope.setTag("vt_dev", "ErrorHandle errorInfo");
      });
    }
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className="page-wrapper">
          <div className="content-wrapper">
            <div className="login-container">
              <div className="login-header">
                <a href="/">
                  <img alt="Vaultoro logo" src={ process.env.REACT_APP_CDN + '/assets/images/logo.svg'} />
                  <span>Vaultoro</span>
                </a>
              </div>
              <h2>Something went wrong...</h2>
              <p style={{ textAlign: 'center' }}>
                It looks like there was an error, please wait a moment and then try again.
                <br />
                If the problem persists, get in touch with the support team.
              </p>
              {/* <details style={{ whiteSpace: 'pre-wrap' }}>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </details> */}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorHandle);
